export default "__VITE_ASSET__D7I0YFNM__"